export interface BackTitlePrimaryProps {
    titleText:string,
    backAction:()=>void
}

const BackTitlePrimary = (props: BackTitlePrimaryProps) => {
    const { titleText, backAction } = props
    
    return (
        <div className="back-title-primary">
            <i className="far fa-arrow-left" onClick={backAction} />
            <div className="Title5">
                {titleText}
            </div>
        </div>  
    )
}
export default BackTitlePrimary
